import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ScenarioParameterModel from './../../Models/ScenarioParameterModel';
import {
  // getModels,
  // getETLs,
  // getDatasets,
  getETL,
  getScenarios,
  getScenario,
  postScenario,
  postDispatchScenarioRun,
  getScenarioRuns,
  postDeleteScenario,
  postDuplicateScenario,
  postEditScenario,
  postEditScenarioTags,
  postScenarioBatch,
  getScenarioBatches,
  postBaselineScenario,
  getScenarioOutput_kpis,
  postGenerateScenarioRunInput,
  postEditRunInput
} from '../../Services/ScenarioService';
import { ScenarioModelDTO } from '../../Models/ScenarioModel';

// export const fetchGitModels = createAsyncThunk('models/fetch', async ( project_id: string,thunkAPI) => {
//   return getModels(project_id);
// });

// export const fetchDatasets = createAsyncThunk('datasets/get', async (thunkAPI) => {
//   return getDatasets();
// });

// export const fetchETLs = createAsyncThunk('ETLs/fetch', async (thunkAPI) => {
//   return getETLs();
// });

export const fetchETL = createAsyncThunk('ETL/fetch', async (ETLId: string, thunkAPI) => {
  return getETL(ETLId);
});

export const fetchScenarios = createAsyncThunk('scenarios/fetch', async (projectId: string, thunkAPI) => {
  return getScenarios(projectId);
});

export const fetchScenarioBatches = createAsyncThunk('scenarioBatch/fetch', async (project_id: string,thunkAPI) => {
  return getScenarioBatches(project_id);
});

export const fetchScenario = createAsyncThunk('scenario/fetch', async (id: string, thunkAPI) => {
  return getScenario(id);
});

export const fetchScenarioRuns = createAsyncThunk(
  'scenario/runs/fetch',
  async (id: string, thunkAPI) => {
    return getScenarioRuns(id);
  }
);

export const fetchSceanrioKPIs = createAsyncThunk('scenarioRunKPI/get', async (thunkAPI) => {
  return getScenarioOutput_kpis();
});

export const createScenarioBatch = createAsyncThunk(
  'scenarioBatch/post',
  async (
    {
      label,
      description,
      projectId,
      modelId,
      tags,
      parameters,
      inputDatasets,
      inputSupplychains,
      dataCombinationPolicy
    }: {
      label: string;
      description: string;
      projectId: string;
      modelId: string;
      tags: string[];
      parameters: ScenarioParameterModel[];
      inputDatasets: string[];
      inputSupplychains: string[];
      dataCombinationPolicy: string;
    },
    thunkAPI
  ) => {
    parameters = parameters.map((parameter: ScenarioParameterModel) => parameter.toObject());

    return postScenarioBatch(
      label,
      description,
      projectId,
      modelId,
      tags,
      parameters,
      inputDatasets,
      inputSupplychains,
      dataCombinationPolicy
    );
  }
);

export const saveScenario = createAsyncThunk(
  'scenarios/post',
  async (scenario: ScenarioModelDTO, thunkAPI) => {
    return postScenario(
      scenario.id,
      scenario.label,
      scenario.description,
      scenario.modelId,
      scenario.inputDatasets,
      scenario.inputSupplychain,
      scenario.parameters,
      scenario.dataCombinationPolicy,
      scenario.batchId
    );
  }
);

export const duplicateScenario = createAsyncThunk(
  'scenarios/duplicate',
  async (scenarioId: string, thunkAPI) => {
    return postDuplicateScenario(scenarioId);
  }
);

export const deleteScenario = createAsyncThunk(
  'scenarios/delete',
  async (scenarioId: string, thunkAPI) => {
    return postDeleteScenario(scenarioId);
  }
);

export const baselineScenario = createAsyncThunk(
  'scenario/baseline',
  async ({scenarioId, projectId}: {scenarioId: string, projectId: string}, thunkAPI) => {
    return postBaselineScenario(scenarioId, projectId);
  }
);

export const dispatchScenarioRun = createAsyncThunk(
  'scenarios/dispatch',
  async (
    {
      scenarioId,
      projectId,
      model,
      replications
    }: { scenarioId: string; projectId: string; model: string; replications: number },
    thunkAPI
  ) => {
    return postDispatchScenarioRun(scenarioId, projectId, model, replications);
  }
);

// export const fetchModelManagementModels = createAsyncThunk(
//   'models/fetchForScenarioCreate',
//   async (project_id:string,thunkAPI) => {
//     return getModels(project_id);
//   }
// );

export const editScenario = createAsyncThunk(
  'scenarios/edit',
  async (
    {
      id,
      label,
      description,
      creationTimestamp,
      createdBy,
      modifiedTimestamp,
      modifiedBy,
      lineage,
      type,
      modelId,
      tags,
      startDate,
      inputData,
      publicScenario
    }: {
      id: string;
      label: string;
      description: string;
      creationTimestamp: string;
      createdBy: string;
      modifiedTimestamp: string;
      modifiedBy: string;
      lineage: string;
      type: string;
      modelId: string;
      tags: string[];
      startDate: string;
      inputData: string[];
      publicScenario: boolean;
    },
    thunkAPI
  ) => {
    return postEditScenario(
      id,
      label,
      description,
      creationTimestamp,
      createdBy,
      modifiedTimestamp,
      modifiedBy,
      lineage,
      type,
      modelId,
      tags,
      startDate,
      inputData,
      publicScenario
    );
  }
);

export const editScenarioTagsSubmit = createAsyncThunk(
  'scenario/editTags',
  async (
    {
      scenarioId,
      tags
    }: {
      scenarioId: string;
      tags: string[];
    },
    thunkAPI
  ) => {
    return postEditScenarioTags(scenarioId, tags);
  }
);

export const generateScenarioRunInput = createAsyncThunk(
  'scenario/generateScenarioRunInput',
  async(
    {
      parameters,
      inputDatasets,
      inputSupplychains,
    }: {
      parameters: ScenarioParameterModel[];
      inputDatasets: string[];
      inputSupplychains: string[];
    },
    thunkAPI
  ) => {
    parameters = parameters.map((parameter: ScenarioParameterModel) => parameter.toObject());
  
    return postGenerateScenarioRunInput(
      inputDatasets,
      inputSupplychains,
      parameters
    );
  }
);

export const editRunInput = createAsyncThunk(
  'scenario/editRunInput',
  async ({blobId, body}:{blobId: string, body: any}, thunkAPI) => {
    return postEditRunInput(blobId, body);
  }
);

// Then, handle actions in your reducers:
export const scenarioData = createSlice({
  name: 'scenarioData',
  initialState: {
    scenarios: Array(),
    scenarioBatches: Array(),
    currentScenario: null,
    models: Array(),
    datasets: Array(),
    ETLRuns: Array(),
    currentETL: null,
    currentScenarioRuns: Array(),
    modelManagementModels: Array(),
    scenarioKPIData: { columns: Array(), data: Array() },
    runInput: null
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    resetCurrentScenario: (state) => {
      state.currentScenario = null;
    },
    resetCurrentScenarioRuns: (state) => {
      state.currentScenarioRuns = Array();
    }
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchScenarios.pending, (state, action) => {
      state.scenarios = [];
    });
    builder.addCase(fetchScenarios.fulfilled, (state, action) => {
      state.scenarios = action.payload;
    });
    builder.addCase(fetchScenarios.rejected, (state, action) => {
      state.scenarios = [];
    });

    builder.addCase(fetchScenarioBatches.pending, (state, action) => {
      state.scenarioBatches = [];
    });
    builder.addCase(fetchScenarioBatches.fulfilled, (state, action) => {
      state.scenarioBatches = action.payload;
    });
    builder.addCase(fetchScenarioBatches.rejected, (state, action) => {
      state.scenarioBatches = [];
    });

    builder.addCase(fetchSceanrioKPIs.pending, (state, action) => {
      state.scenarioKPIData = { columns: [], data: [] };
    });
    builder.addCase(fetchSceanrioKPIs.fulfilled, (state, action) => {
      state.scenarioKPIData = action.payload;
    });
    builder.addCase(fetchSceanrioKPIs.rejected, (state, action) => {
      state.scenarioKPIData = { columns: [], data: [] };
    });

    builder.addCase(createScenarioBatch.fulfilled, (state, action) => {
      state.scenarioBatches = [...state.scenarioBatches, action.payload['batch']];
      state.scenarios = [...state.scenarios, ...action.payload['scenarios']];
      state.currentScenario = action.payload['scenarios'].slice(-1)[0];
    });
    builder.addCase(fetchScenario.pending, (state, action) => {
      state.currentScenario = null;
    });
    builder.addCase(fetchScenario.fulfilled, (state, action) => {
      state.currentScenario = action.payload;
    });
    builder.addCase(fetchScenario.rejected, (state, action) => {
      state.currentScenario = null;
    });
    builder.addCase(fetchScenarioRuns.fulfilled, (state, action) => {
      state.currentScenarioRuns = [...action.payload];
    });
    // builder.addCase(fetchGitModels.pending, (state, action) => {
    //   state.models = [];
    // });
    // builder.addCase(fetchGitModels.fulfilled, (state, action) => {
    //   state.models = action.payload;
    // });
    // builder.addCase(fetchModelManagementModels.pending, (state, action) => {
    //   state.modelManagementModels = [];
    // });
    // builder.addCase(fetchModelManagementModels.fulfilled, (state, action) => {
    //   state.modelManagementModels = action.payload;
    // });

    // builder.addCase(fetchDatasets.pending, (state, action) => {
    //   state.datasets = [];
    // });
    // builder.addCase(fetchDatasets.fulfilled, (state, action) => {
    //   state.datasets = action.payload;
    // });

    // builder.addCase(fetchETLs.pending, (state, action) => {
    //   state.ETLRuns = [];
    // });
    // builder.addCase(fetchETLs.fulfilled, (state, action) => {
    //   state.ETLRuns = action.payload;
    // });

    builder.addCase(fetchETL.pending, (state, action) => {
      state.currentETL = null;
    });
    builder.addCase(fetchETL.fulfilled, (state, action) => {
      state.currentETL = action.payload;
    });
    builder.addCase(editScenario.fulfilled, (state, action) => {
      let scenarioId = action.payload.id;

      let index = state.scenarios.findIndex((s) => s.id === scenarioId);

      state.scenarios.splice(index, 1);

      state.scenarios.push(action.payload);
      state.scenarios.sort((s) => s.creationTimestamp);
    });
    builder.addCase(generateScenarioRunInput.fulfilled, (state, action) => {
      state.runInput = action.payload;
    });
  }
});

export const { 
  resetCurrentScenario, 
  resetCurrentScenarioRuns 
} = scenarioData.actions;

export default scenarioData.reducer;
